import * as React from "react";
import {
    Box,
    Typography,
    SxProps,
    Theme,
    CardMedia,
    Card,
    CardContent,
} from "@mui/material";
import { AboutUsPerson } from "../types";

export type PersonCardMobileProps = {
    person: AboutUsPerson;
};

const PersonCardMobileStyle: Record<string, SxProps<Theme>> = {
    cardContainer: {
        maxWidth: "100%",
        margin: "10px",
    },
    cardHeaderContainer: (theme: Theme) => ({}),
    cardTitle: {
        fontSize: "20px",
        textAlign: "center",
    },
    cardSubtitle: {
        fontSize: "16px",
        textAlign: "center",
    },
};

const PersonCardMobile: React.FC<PersonCardMobileProps> = ({ person }) => {
    return (
        <Card
            sx={{
                width: "100%",
                height: "500px",
                background: "transparent",
                boxShadow: "none",
            }}
        >
            <CardMedia
                sx={{
                    width: "100%",
                    height: "350px",
                    border: "1px solid white",
                    backgroundPosition: "top",
                }}
                image={person.image}
            />
            <CardContent>
                <Box sx={PersonCardMobileStyle.cardHeaderContainer}>
                    <Typography sx={PersonCardMobileStyle.cardTitle}>
                        {person.name}
                    </Typography>
                    <Typography sx={PersonCardMobileStyle.cardSubtitle}>
                        {person.position}
                    </Typography>
                </Box>
            </CardContent>
        </Card>
    );
};

export default PersonCardMobile;
